export type SocialNetwork = {
  id: string;
  networkType: SocialNetworkType;
  url: string;
};

export const SocialNetworkType = {
  Facebook: 'facebook',
  Instagram: 'instagram',
  Twitter: 'twitter',
  YouTube: 'youtube',
  TikTok: 'tiktok',
  Threads: 'threads',
  WhatsApp: 'whatsapp',
  Bluesky: 'bluesky',
} as const;
export type SocialNetworkType = (typeof SocialNetworkType)[keyof typeof SocialNetworkType];
